/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';

import Navbar from '~/components/layout/NavbarNew';
import UserMenu from '~/components/layout/UserMenu';
import Question from '~/components/Granel/duvidas';

import {
  Container,
  PageTitle,
  Shortcut,
  ShortcutContainer,
  ShortcutIcon,
  ShortcutText,
  ShortcutLink,
  UserResponsive,
} from './styles';

class PerguntasFrequentes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  render() {
    return (
      <Navbar selected="PerguntasFrequentes">
        <UserResponsive>
          <UserMenu />
        </UserResponsive>
        <Container>
          <PageTitle>Perguntas Frequentes</PageTitle>
          <Question
            question="Em qual momento devo solicitar meu gás?"
            answer="Em até 48 horas antes do dia da rota"
          />
          <Question
            question="Qual % é seguro para não ficar sem gás?"
            answer="Recomendamos que 30% é uma porcentagem segura"
          />
          <Question
            question="Como identifico a porcentagem do gás?"
            answer="Basta verificar no relógio que fica em cima do vasilhame o magnetron"
          />
          <Question
            question="Como identifico se o gás está ligado no medidor?"
            answer="Basta verificar se todas as partes estão encaixadas e se a borboleta do regulador  está no sentido da tubulação"
          />
        </Container>
      </Navbar>
    );
  }
}

export default PerguntasFrequentes;
